import React, { useState, useEffect } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import countries from "../../constant/countries";

const NationalCompany = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { countryName } = useParams();

  // Match single country for flag + title
  const matchedCountry = countries.find(
    (c) =>
      c.name.toLowerCase().replace(/\s+/g, "-") ===
      countryName.toLowerCase().replace(/\s+/g, "-")
  );

  // Selected countries from state OR fallback to URL country
  const stateCountries = location.state?.selectedCountries || [];
  const selectedCountries =
    stateCountries.length > 0
      ? stateCountries
      : [countryName.replace(/-/g, " ")];

  const matchedCountries = selectedCountries
    .map((name) =>
      countries.find(
        (c) =>
          c.name.toLowerCase().replace(/\s+/g, "-") ===
          name.toLowerCase().replace(/\s+/g, "-")
      )
    )
    .filter(Boolean);

  const [formData, setFormData] = useState({
    full_name: "",
    last_name: "",
    email: "",
    phone_number: "",
    city: "",
    comments: "",
    file: null,
    category: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    setFormData((prev) => ({ ...prev, file: e.target.files[0] }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.file) {
      toast.error("Please upload an ad file.");
      return;
    }

    const submissionData = new FormData();
    for (const key in formData) {
      submissionData.append(key, formData[key]);
    }

    submissionData.append(
      "countries",
      matchedCountries.map((c) => c.name).join(", ")
    );

    try {
      const response = await fetch("http://localhost:5000/api/upload", {
        method: "POST",
        body: submissionData,
      });

      if (response.ok) {
        toast.success("Form submitted successfully!");
        setTimeout(() => navigate("/payment-form"), 1000);

        setFormData({
          full_name: "",
          last_name: "",
          email: "",
          phone_number: "",
          city: "",
          comments: "",
          file: null,
          category: "",
        });
      } else {
        toast.error("Failed to submit the form.");
      }
    } catch (error) {
      console.error("Submission error:", error);
      toast.error("An error occurred during submission.");
    }
  };

  return (
    <>
      {/* Hero Section */}
      <section
        className="relative text-white min-h-[80vh] flex items-center justify-center overflow-hidden"
        style={{
          background:
            "linear-gradient(90deg, rgba(252, 53, 236, 1) 0%, rgba(237, 0, 170, 1) 100%)",
        }}
      >
        <div
          className="absolute inset-0 bg-cover bg-center opacity-30"
          style={{
            backgroundImage:
              "url('https://images.unsplash.com/photo-1616692474781-9ef0114c15b1?ixlib=rb-4.0.3&auto=format&fit=crop&w=1470&q=80')",
          }}
        ></div>

        <div className="relative z-10 text-center px-4 sm:px-6 max-w-5xl">
          {matchedCountry && (
            <img
              src={matchedCountry.flag}
              alt={matchedCountry.name}
              className="w-64 h-auto mx-auto mt-4 rounded"
            />
          )}
          <h1 className="text-4xl mt-4 uppercase sm:text-5xl md:text-6xl font-extrabold tracking-tight font-[Aeonik] leading-tight">
            Women of {matchedCountry ? matchedCountry.name : countryName}, Inc.
          </h1>
        </div>
      </section>

      {/* Form */}
      <div className="max-w-5xl mx-auto px-6 py-12">

      <h2 className="text-3xl font-extrabold mb-6 text-main-pink">
        Business Form
      </h2>

        <form
          onSubmit={handleSubmit}
          className="space-y-6 bg-white shadow-md rounded-xl p-6"
        >
          {/* Selected Country Names */}
          <div>
            <label className="block text-gray-700 font-medium mb-2">
              Selected Countries
            </label>
            <textarea
              readOnly
              value={matchedCountries.map((c) => c.name).join(", ")}
              rows={2}
              className="w-full border border-gray-300 rounded-lg p-3 bg-gray-100 text-gray-700"
            />
          </div>

          {/* Input Fields */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {[
              { name: "full_name", label: "Full Name" },
              { name: "last_name", label: "Last Name" },
              { name: "email", label: "Email", type: "email" },
              { name: "phone_number", label: "Phone", type: "tel" },
              { name: "city", label: "Website URL" },
              { name: "category", label: "Business Category" },
            ].map(({ name, label, type = "text" }) => (
              <input
                key={name}
                type={type}
                name={name}
                value={formData[name]}
                onChange={handleChange}
                placeholder={label}
                className="w-full border border-gray-300 rounded-lg p-3 focus:ring-2 focus:ring-pink-500 transition-shadow shadow-md hover:shadow-lg"
                required
              />
            ))}
          </div>

          {/* Comments */}
          <div>
            <textarea
              name="comments"
              value={formData.comments}
              onChange={handleChange}
              placeholder="Comments or Questions"
              rows={4}
              className="w-full border border-gray-300 rounded-lg p-3"
            />
          </div>

          {/* Submit */}
          <div className="text-center pt-4">
            <button
              type="submit"
              className="bg-pink-600 text-white py-2 px-6 rounded hover:bg-pink-700 transition"
            >
              Submit Form
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

export default NationalCompany;
